// extracted by mini-css-extract-plugin
export default {"layout":"WalletActiveScreen_layout__YzHui","leftColumn":"WalletActiveScreen_leftColumn__OcM0V","rightColumn":"WalletActiveScreen_rightColumn__XaEku"};